import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const PrimaryBox = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'column', 'row'],
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.xxl,
    ],
  }),
);

export const SecondaryBox = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: ['1fr', '1fr', '1fr', '1fr', '1fr auto'],
    gridColumnGap: '40px',
    alignItems: 'flex-start',
    width: '100%',
  }),
);

export const RaceInfoTableHead = styled.div(() =>
  mq({
    display: 'flex',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const RaceInfoTypeSelectorWrapper = styled.div(() =>
  mq({
    flex: 1,
  }),
);

export const LineForecastWrapper = styled.div(() => mq({}));

export const RaceCardFooter = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    margin: `${defaultTheme.spacing.l} ${defaultTheme.spacing.l} ${defaultTheme.spacing.l} 0`,
  }),
);

export const CheckBoxWrapper = styled.div(() =>
  mq({
    margin: 0,
  }),
);

export const LiveMovieWrapper = styled.div(() =>
  mq({
    position: ['fixed', 'fixed', 'fixed', 'fixed', 'inherit'],
    width: ['290px', '290px', '290px', '290px', '100%'],
    height: ['163px', '163px', '163px', '163px', 'auto'],
    zIndex: [999, 999, 999, 999, '1'],
    bottom: defaultTheme.spacing.m,
    left: defaultTheme.spacing.m,
    '& > div': {
      marginBottom: defaultTheme.spacing.xxl,
    },
  }),
);
